exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".settings-dispatch-receivers__toolbar[data-v-ed62ae68]{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-bottom:10px}.settings-dispatch-receivers__toolbar-right[data-v-ed62ae68]{display:flex;align-items:center;gap:8px}.settings-dispatch-receivers__search[data-v-ed62ae68]{width:320px}.settings-dispatch-receivers__liaison-select[data-v-ed62ae68]{width:100%}.settings-dispatch-receivers__pager[data-v-ed62ae68]{margin-top:12px;display:flex;justify-content:flex-end}.settings-dispatch-receivers__danger[data-v-ed62ae68]{color:#f56c6c}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ed62ae68","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/views/SettingsDispatchReceivers.vue
// module id = jVe6
// module chunks = 0